import { fabric } from 'fabric';

export const isTransparent = (color?: string) =>
  !color || color === 'transparent';

// Sanitize an incoming color so that it matches a 6 digit CSS hex value.
export function cleanupColor(color: string) {
  if (isTransparent(color)) return color;
  const parsed = new fabric.Color(color);
  return `#${parsed.toHex()}`;
}

export const cleanupColorArray = (raw: unknown) =>
  Array.isArray(raw) ? raw.map(cleanupColor).filter(Boolean) : [];

export const customColorKey = 'custom-whiteboard-colors';

export function getCustomColors(): string[] {
  try {
    const stored = localStorage.getItem(customColorKey);
    if (stored) {
      return cleanupColorArray(JSON.parse(stored));
    }
  } catch (error) {
    console.warn('Failed to retrieve custom colors from localStorage:', error);
  }
  return [];
}
